import {
  conferenceGalleries,
  corporateRetreatGalleries,
} from '@/data/adventureGalleries';

function destinationLabel(destination = {}) {
  return [destination.city, destination.region, destination.country]
    .filter(Boolean)
    .filter((value, index, values) => values.indexOf(value) === index)
    .join(', ');
}

function migrateJourney(gallery, journeyType) {
  const destination = destinationLabel(gallery.destination);

  return {
    id: gallery.slug,
    slug: gallery.slug,
    contentType: 'journey',
    journeyType,
    title: gallery.title,
    eyebrow: gallery.meta || gallery.tripType || journeyType,
    summary: gallery.summary || gallery.description || gallery.subtitle,
    image: gallery.coverImage || gallery.heroImage,
    href: { name: 'reckon-way-gallery', params: { gallerySlug: gallery.slug } },
    metadata: [gallery.dateLabel, destination, gallery.tripType].filter(Boolean),
    tags: gallery.tags || [],
  };
}

export const retreatJourneys = corporateRetreatGalleries
  .map((gallery) => migrateJourney(gallery, 'Corporate Retreat'));

export const conferenceJourneys = conferenceGalleries
  .map((gallery) => migrateJourney(gallery, 'Conference'));

export const journeySections = [
  {
    id: 'corporate-retreats',
    title: 'Corporate Retreats',
    eyebrow: 'Explore Together',
    description: 'Family-inclusive destination adventures built around shared firsts, memorable meals, and time together beyond the office.',
    items: retreatJourneys,
  },
  {
    id: 'conferences',
    title: 'Conferences',
    eyebrow: 'Learn on the Road',
    description: 'Industry events that become larger journeys through new cities, ideas, food, music, and culture.',
    items: conferenceJourneys,
  },
];

export default journeySections;
